import { h } from 'preact'
import {emojify} from 'react-emojione-preact'
import style from './styles/message.scss'

import Summary from './Summary'
import Dots from './Dots'

const Typing = () => (
  <Dots />
)

const paragraphs = m => m.map(p => (
  Array.isArray(p) ?
  <Summary summary={p} />
  : <p class={style.text}>{emojify(p, {style: {height: 20}})}</p>
))

const Content = ({message, data, timestamp}) => (
  <div>
    <p class={style.date}>{timestamp}</p>
    {Array.isArray(message) ?
      paragraphs(message)
      : typeof message === 'function' ?
      paragraphs(message(data))
      : <p class={style.text}>{emojify(message, {style: {height: 20}})}</p>
    }
  </div>
)

const Message = ({message, data, timestamp, isHistory = false, isTyping = false}) => (
  <div class={!isTyping ? (isHistory ? style.history : style.normal) : style.typing}>
    <figure class={style.ava}>
      <img src="/assets/img/chatbot.png" class={style.ava_image} />
    </figure>
    <div class={isHistory ? style.message : (isTyping ? style.message : style.animated)}>
      {isTyping ? <Typing />
        : <Content message={message} data={data} timestamp={timestamp} />
      }
    </div>
  </div>
)

export default Message



// WEBPACK FOOTER //
// ./components/ChatBot/Message.js